import { X } from "lucide-react"
import { HTMLAttributes } from "react"
import { TagColor } from "shared-ts/libs/tag"

import { classNames } from "../../../../lib/classNames"
import { Icon, IconSizes } from "../../../Icon"

const tagBackgroundColorClasses: Record<TagColor, string> = {
  [TagColor.Undefined]: "bg-transparent",
  [TagColor.Red]: "bg-accent-red",
  [TagColor.Pink]: "bg-accent-pink",
  [TagColor.Purple]: "bg-accent-violet",
  [TagColor.Blue]: "bg-accent-blue",
  [TagColor.Cyan]: "bg-accent-sky",
  [TagColor.Green]: "bg-accent-green",
  [TagColor.Yellow]: "bg-accent-amber",
  [TagColor.Gray]: "bg-accent-gray",
}

export interface TagProps extends HTMLAttributes<HTMLDivElement> {
  name?: string
  color: TagColor
  isColorSwatchTag?: boolean
  onDelete?: () => void
}

export function Tag({
  name,
  color,
  onDelete,
  className,
  isColorSwatchTag,
  ...otherProps
}: TagProps) {
  return (
    <div
      className={classNames(
        "flex items-center gap-x-1",
        "h-6.5 w-fit",
        "rounded-4xl px-2",
        tagBackgroundColorClasses[color],
        isColorSwatchTag && "rounded-xs h-4 w-4",
        className
      )}
      {...otherProps}
    >
      <span
        className={classNames(
          "text-body select-none whitespace-nowrap",
          "color-default opacity-90"
        )}
      >
        {name}
      </span>
      {onDelete && (
        <button
          type="button"
          className="flex h-4 w-4 items-center justify-center"
        >
          <Icon
            icon={X}
            size={IconSizes.ExtraSmall}
            className="color-icon-bold opacity-50 focus:opacity-75 active:opacity-75"
            onClick={(e) => {
              e.stopPropagation()
              onDelete()
            }}
            aria-label="Delete tag icon"
          />
        </button>
      )}
    </div>
  )
}
